Ext.define('SA.view.ExportShapefiles.AttributeList', {
    alias: 'widget.export-shapefiles-attribute-list',
    extend: 'Ext.Component',

    autoEl: 'ul',
    cls: 'sa-shapefiles-attribute-list',

    tpl: [
        '<tpl for=".">',
            '<li data-id="{attribute:htmlEncode}" class="sa-shapefiles-attribute',
                '<tpl if="selected"> sa-shapefiles-attribute-selected</tpl>',
                '<tpl if="disabled"> sa-shapefiles-attribute-disabled</tpl>"',
                '<tpl if="title"> title="{title:htmlEncode}"</tpl>',
            '>',
                '<div class="sa-shapefiles-attribute-checkbox"></div>',
                '<div class="sa-shapefiles-attribute-text">{name:htmlEncode}, {year}</div>',
            '</li>',
        '</tpl>'
    ],

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-shapefiles-attribute',

            click: (ev, target) => {
                if (isDisabled(ev)) {
                    return;
                }

                this.fireEvent('click:attribute', target.getAttribute('data-id'));
            },

            mouseout(ev, target) {
                if (isDisabled(ev)) {
                    return;
                }

                Ext.fly(target).removeCls('sa-shapefiles-attribute-hover');
            },

            mouseover(ev, target) {
                if (isDisabled(ev)) {
                    return;
                }

                Ext.fly(target).addCls('sa-shapefiles-attribute-hover');
            }
        });

        function isDisabled(ev) {
            return ev.getTarget('.sa-shapefiles-attribute-disabled');
        }
    }
});